import React, { useEffect, useState, useRef } from "react";
import ClassNames from "classnames";
import { Formik, getIn, Field } from "formik";
import ReCAPTCHA from "react-google-recaptcha";
import ALiYunCaptcha from "react-aliyun-captcha";
import queryString from "query-string";
import * as Yup from "yup";
import { UserIPLocation } from "../../components/Layout";
import {
  getAllCountryNames,
  getAllCountryNamesForChina,
  getContentData,
  getStaticData,
} from "../../helperFunctions";
import Select from "./Select";
import TextField from "../../components/TextField";
import Button from "../../components/Button";
import * as s from "./businessEnquiry.module.scss";
import { Content } from "./content";
import StaticContent from "../../../content/forms";
import { API, CmsFormPostAPI } from "../../AxiosInstances";
import {
  PhoneInput,
  // FlagImage,
  defaultCountries,
  // parseCountry,
} from "react-international-phone";
import { isValidPhoneNumber } from "libphonenumber-js";
import "react-international-phone/style.css";
import axios from "axios";

const isPhoneValid = (phoneNumber) => {
  try {
    return isValidPhoneNumber(phoneNumber);
  } catch (error) {
    return false;
  }
};

function Checkbox1({ label, field, type, checked, disabled, themeSecondary }) {
  return (
    <div className={ClassNames(s.checkboxAlign)}>
      <input
        id="business__enquiry__terms__condition"
        {...field}
        type={type}
        checked={checked}
        className={ClassNames(s.checkbox, {
          [s.checkBoxSecondary]: themeSecondary,
        })}
        disabled={disabled}
      />
      <label
        style={{ marginInlineStart: "-28px" }}
        htmlFor="business__enquiry__terms__condition"
      >
        {label}
      </label>
    </div>
  );
}

function Checkbox2({ label, field, type, checked, disabled, themeSecondary }) {
  return (
    <div style={{ paddingTop: "20px" }} className={ClassNames(s.checkboxAlign)}>
      <input
        id={field.name}
        {...field}
        type={type}
        checked={checked}
        className={ClassNames(s.checkbox, {
          [s.checkBoxSecondary]: themeSecondary,
        })}
        disabled={disabled}
      />
      <label style={{ marginInlineStart: "-28px" }} htmlFor={field.name}>
        {label}
      </label>
    </div>
  );
}

const EnquiryForm = ({
  featuredContact,
  locale,
  isSent,
  setIsSent,
  responseError,
  setResponseError,
  selectedEnquiryType,
  withRespectedCountry,
  setSelectedEnquiryType,
  customGTMBusiness,
  businessEnquiry,
  isCxTalks = false,
  ebook,
  isgreport = false,
  downloadableEbook,
  customSubjectSuffix,
  themeSecondary,
  defaultOption = "",
  origin = "",
  ebookTitle,
  report = false
}) => {
  const tdcxCN = process.env.GATSBY_BUILD_SITE === "china";
  const ApiUrl = process.env.API_URL;
  const [countriesList, setCountriesList] = useState([]);
  const [showCaptcha, setShowCaptcha] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const isValid = isPhoneValid(phoneNumber);

  const customFlags = defaultCountries.map((subArray) => ({
    iso2: subArray[1],
    src: `https://flagcdn.com/${subArray[1]}.svg`,
  }));

  const messageBlocker = getContentData(
    Content,
    "content_block",
    "global",
    "Blocking Messages"
  )
    .description.data.description.replace(/<p>|&nbsp;|\r|<br>|\n/gi, "|")
    .replace("</p>", "|")
    .replace(/\|+/g, "|")
    .replace(/^\||\|$/g, "");

  const companyBlocker = getContentData(
    Content,
    "content_block",
    "global",
    "Blocking Company name"
  )
    .description.data.description.replace(/<p>|&nbsp;|\r|<br>|\n/gi, "|")
    .replace("</p>", "|")
    .replace(/\|+/g, "|")
    .replace(/^\||\|$/g, "");

  const emailBlocker = getContentData(
    Content,
    "content_block",
    "global",
    "Blocking Email"
  )
    .description.data.description.replace(/<p>|&nbsp;|\r|<br>|\n/gi, "|")
    .replace("</p>", "|")
    .replace(/\|+/g, "|")
    .replace(/^\||\|$/g, "");

  const initialValues = {
    enquiryType: selectedEnquiryType,
    firstName: "",
    lastName: "",
    name: "",
    email: "",
    jobRole: "",
    preferredLocation: "",
    ...(!withRespectedCountry && { companyName: "" }),
    ...(!withRespectedCountry && { headcount: "" }),
    ...(!withRespectedCountry && { companyIndustry: "" }),
    ...(!withRespectedCountry && { preferredLanguage: "" }),
    phoneNumber: {
      number: "",
      countryCode: "",
    },
    ...(!withRespectedCountry && { solutions: defaultOption }),
    message: "",
    origin: "",
    captcha: "",
    hasAgreedTerm: false,
    marketing_consent: false,
    tdcxCN: tdcxCN,
  };

  const catchFormError = (setSubmitting, setFieldValue, setFieldTouched) => {
    setSubmitting(false);
    setFieldValue("captcha", "");
    setFieldTouched("captcha", false);
    typeof window !== "undefined" && !tdcxCN && window.grecaptcha.reset();
    setResponseError(
      getStaticData(StaticContent.something_went_wrong_please_try_again, locale)
        .title
    );
  };

  const getAllValuesForAPI = (values) => {
    let captcha;
    if (tdcxCN) {
      let captchaObj = Object.assign({}, values.captcha);
      captchaObj.cType = "cn";
      captcha = JSON.stringify(captchaObj);
    } else {
      captcha = values.captcha;
    }

    return {
      fullName: `${values.firstName} ${values.lastName}`,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email.toLowerCase(),
      preferredLocation: selectedEnquiryType.value === "BUSINESS" ? values.preferredLocation
        .map((y) => {
          return y.label.toLowerCase();
        })
        .join(", ") : values.preferredLocation.label,
      ...(!withRespectedCountry && { companyName: values.companyName }),
      ...(!withRespectedCountry && { headcount: values.headcount.value }),
      ...(!withRespectedCountry && {
        companyIndustry: values.companyIndustry.value,
      }),
      ...(!withRespectedCountry && {
        preferredLanguage: values.preferredLanguage.value,
      }),
      code: values.phoneNumber.countryCode,
      phone: values.phoneNumber.number,
      ...(!withRespectedCountry && { solutions: values.solutions.value }),
      message: values.message,
      captcha: captcha,
      subjectSuffix: customSubjectSuffix
        ? customSubjectSuffix
        : `from ${values.firstName} ${values.lastName}`,
      tdcxCN: tdcxCN,
      lang: locale,
      origin: origin,
    };
  };

  const getAllValuesForCMS = (values) => {
    return {
      full_name: `${values.firstName} ${values.lastName}`,
      first_name: values.firstName,
      last_name: values.lastName,
      ...(ebook && { name: values.name }),
      ...(isgreport && { first_name: values.name }),
      ...(ebook && { company_name: values.companyName }),
      ...(ebook && { job_role: values.jobRole }),
      ...(ebook && { ebook_title: ebookTitle }),

      email: values.email.toLowerCase(),
      ...(!ebook && {
        preferred_location: selectedEnquiryType.value === "BUSINESS" ? values.preferredLocation
          .map((y) => {
            return y.label.toLowerCase();
          })
          .join(", ") : values.preferredLocation.value,
      }),
      ...(!withRespectedCountry && { company_name: values.companyName }),
      ...(!withRespectedCountry && { headcount: values.headcount.value }),
      ...(!withRespectedCountry && {
        companyIndustry: values.companyIndustry.value,
      }),
      ...(!withRespectedCountry && {
        preferredLanguage: values.preferredLanguage.value,
      }),
      phone_number: `${values.phoneNumber.countryCode}${values.phoneNumber.number}`,
      ...(!withRespectedCountry && { solutions: values.solutions.value }),
      message: values.message,
      tdcxCN: tdcxCN,
      origin: origin,
      emailSent: false
    };
  };

  const getValidationSchema = () => {
    if (businessEnquiry === true) {
      selectedEnquiryType = {};
      selectedEnquiryType.value = "BUSINESS";
    }
    return Yup.object().shape({
      ...(!businessEnquiry &&
        !ebook && {
          enquiryType: Yup.object().required(
            getStaticData(StaticContent.required_enquiry_type, locale).title
          ),
        }),
      ...(!ebook && {
        firstName: Yup.string()
          .required(
            getStaticData(StaticContent.required_first_name, locale).title
          )
          .test(
            "regexFirstName",
            getStaticData(StaticContent.valid_name, locale).title,
            (val) => {
              var regex =
                /^[\u4E00-\u9FFF\uAC00-\uD7AF\u3040-\u309F\u30A0-\u30FFa-zA-Z\s]+$/;
              var regexStatus = regex.test(val);
              if (regexStatus) {
                return val;
              }
            }
          ),
      }),
      ...(!ebook && {
        lastName: Yup.string()
          .required(
            getStaticData(StaticContent.required_last_name, locale).title
          )
          .test(
            "regexLastName",
            getStaticData(StaticContent.valid_name, locale).title,
            (val) => {
              var regex =
                /^[\u4E00-\u9FFF\uAC00-\uD7AF\u3040-\u309F\u30A0-\u30FFa-zA-Z\s]+$/;
              var regexStatus = regex.test(val);
              if (regexStatus) {
                return val;
              }
            }
          ),
      }),
      ...(ebook && {
        name: Yup.string()
          .required(getStaticData(StaticContent.required_name, locale).title)
          .test(
            "regexName",
            getStaticData(StaticContent.valid_name, locale).title,
            (val) => {
              var regex =
                /^[\u4E00-\u9FFF\uAC00-\uD7AF\u3040-\u309F\u30A0-\u30FFa-zA-Z\s]+$/;
              var regexStatus = regex.test(val);
              if (regexStatus) {
                return val;
              }
            }
          ),
      }),
      ...(ebook && {
        jobRole: Yup.string().required(
          getStaticData(StaticContent.required_jobRole, locale).title
        ),
      }),
      ...(selectedEnquiryType.value === "BUSINESS" ||
      selectedEnquiryType.value === "VENDOR" ||
      ebook
        ? {
            email: Yup.string()
              .email(getStaticData(StaticContent.valid_email, locale).title)
              .required(
                getStaticData(StaticContent.required_email, locale).title
              )
              .test(
                "regexEmail",
                getStaticData(StaticContent.valid_business_email, locale).title,
                (val) => {
                  var regex1 = new RegExp(
                    `^(?!.*@.*(${emailBlocker
                      .split("|")
                      .filter((item) => item.includes("@"))
                      .map((item) => item.slice(1))
                      .join("|")})\\w*)(?!.*@.*\\d)(.+@.+\\..+)$`
                  );
                  var regexStatus = regex1.test(val);
                  if (regexStatus) {
                    return val;
                  }
                }
              ),
          }
        : {
            email: Yup.string()
              .email(getStaticData(StaticContent.valid_email, locale).title)
              .required(
                getStaticData(StaticContent.required_email, locale).title
              ),
          }),
      ...(!ebook && {
        preferredLocation: selectedEnquiryType.value === "BUSINESS" ? Yup.array().required(
          getStaticData(StaticContent.required_preferred_location, locale).title
        ) : Yup.object().required(
          getStaticData(StaticContent.required_preferred_location, locale).title
        ),
      }),
      ...(!withRespectedCountry && {
        companyName: Yup.string()
          .required(
            getStaticData(StaticContent.required_company_name, locale).title
          )
          .test(
            "regexCompany",
            getStaticData(StaticContent.valid_company_name, locale).title,
            (val) => {
              var regex1 = `${companyBlocker}`
                .toLowerCase()
                .split("|")
                .filter((x) => {
                  return x != "";
                });
              var regex2 =
                /^(?=.*[A-Za-z])([A-Za-z0-9 .,-]|[\u4E00-\u9FFF\uAC00-\uD7AF\u3040-\u309F\u30A0-\u30FF]){1,31}(\s+([A-Za-z0-9 .,-]|[\u4E00-\u9FFF\uAC00-\uD7AF\u3040-\u309F\u30A0-\u30FF]){1,31})*$|^[\u4E00-\u9FFF\uAC00-\uD7AF\u3040-\u309F\u30A0-\u30FF]+$/;
              var regexStatus =
                val &&
                !regex1.some((substring) =>
                  val.toLowerCase().includes(substring)
                ) &&
                regex2.test(val);
              // &&
              // regex3.test(val);
              if (regexStatus) {
                return val;
              }
            }
          ),
      }),
      ...(!withRespectedCountry &&
        !ebook && {
          headcount: Yup.object().required(
            getStaticData(StaticContent.required_headcount, locale).title
          ),
          companyIndustry: Yup.object().required(
            getStaticData(StaticContent.required_company_industry, locale).title
          ),
          preferredLanguage: Yup.object().required(
            getStaticData(StaticContent.required_preferred_language, locale)
              .title
          ),
        }),
      ...(!ebook && {
        phoneNumber: Yup.object().shape({
          number: Yup.string()
            .required(
              getStaticData(StaticContent.required_phone_no, locale).title
            )
            .test(
              "regexPhone",
              getStaticData(StaticContent.valid_phone_no, locale).title,
              (val) => {
                var regex1 = isValid;
                var regexStatus = regex1;
                if (regexStatus) {
                  return val;
                }
              }
            ),
          countryCode: Yup.string().required(
            getStaticData(StaticContent.required_country_code, locale).title
          ),
        }),
      }),
      ...(!withRespectedCountry &&
        !ebook && {
          solutions: Yup.object().required(
            getStaticData(StaticContent.required_solutions, locale).title
          ),
        }),
      ...(!ebook && {
        message: Yup.string()
          .required(getStaticData(StaticContent.required_message, locale).title)
          .test(
            "regexMessage",
            getStaticData(StaticContent.valid_message, locale).title,
            (val) => {
              var regexConstruct = `${messageBlocker}`.toLowerCase().split("|");

              regexConstruct = regexConstruct.filter(function (el) {
                return el != "";
              });

              if (
                val &&
                !regexConstruct.some((substring) =>
                  val.toLowerCase().includes(substring)
                )
              ) {
                return val;
              }
            }
          ),
      }),
      ...(!ebook && {
        captcha: Yup.object().required(),
      }),
      ...(!ebook && {
        hasAgreedTerm: Yup.boolean().oneOf(
          [true],

          getStaticData(StaticContent.required_terms_privacy, locale).title
        ),
      }),
      marketing_consent: Yup.boolean(),
    });
  };

  const getAPIEndPoint = (enquiryTypeValue) => {
    const endpoints = {
      BUSINESS: "/email/sendBusinessEnquiry/",
      JOB: "/email/sendJobEnquiry/",
      VENDOR: "/email/sendVendorEnquiry",
    };
    return endpoints[enquiryTypeValue] || endpoints.BUSINESS;
  };

  const getCMSEndPoint = (enquiryTypeValue) => {
    const endpoints = {
      BUSINESS: "/businessenquiries",
      JOB: "/jobenquiries",
      VENDOR: "/vendorenquiries",
      EBOOK: "/ebookdownloads",
      ISGREPORT: "/isgreports",
    };
    return endpoints[enquiryTypeValue] || endpoints.BUSINESS;
  };

  const countriesRef = useRef(false);
  if (!countriesRef.current) {
    if (tdcxCN || locale === "zh" || locale === "cn-zh") {
      getAllCountryNamesForChina().then((countriesList) => {
        let countries = countriesList.map((country) => ({
          value: getStaticData(country.value, locale),
          label: getStaticData(country.value, locale),
        }));
        setCountriesList(countries);
      });
    } else {
      getAllCountryNames().then((countriesList) => {
        let countries = countriesList.map((country) => ({
          value: getStaticData(country.value, locale),
          label: getStaticData(country.value, locale),
        }));
        setCountriesList(countries);
      });
    }
    countriesRef.current = true;
  }

  const sendCustomGTMEvent = (type) => {
    switch (type) {
      case "JOB":
        window.dataLayer.push({
          event: "Job Enquiry Form Submit",
        });
        break;
      case "BUSINESS":
        window.dataLayer.push({
          event: customGTMBusiness
            ? customGTMBusiness
            : "Business Enquiry Form Submit",
        });
        break;
      case "CXTALKS":
        window.dataLayer.push({
          event: "CX Talks Form Submission",
        });
        break;
      case "VENDOR":
        window.dataLayer.push({
          event: "Vendor Enquiry Form Submit",
        });
        break;
      case "EBOOK":
        window.dataLayer.push({
          event: "Industry Insight-Business Enquiry Form Submit",
        });
        break;
      default:
        window.dataLayer.push({
          event: "Business Enquiry Form Submit",
        });
    }
  };

  const sendHubspotEvent = (values) => {
    // const timestampNow = new Date();
    // get hubspot hutk from cookies
    let hubspotUTK = null;
    let hutkCookie = document.cookie
      .split("; ")
      .find((row) => row.startsWith("hubspotutk"));
    if (hutkCookie) {
      let eqIndex = hutkCookie.indexOf("=");
      hubspotUTK = hutkCookie.slice(eqIndex + 1, hutkCookie.length);
    }
    let eBookData = {};
    let formData = {};

    if (ebook) {
      eBookData = {
        //Actual fields with data
        formId: "7564359/53b45baf-9ad0-4176-9e90-06e225fe17ae",
        firstName: values.name,
        email: values.email,
        companyName: values.companyName,
        job_role: values.jobRole,
        pageUri:
          typeof window !== "undefined" ? window.location.href : undefined,
        pageName: typeof document !== "undefined" ? document.title : undefined,
        hutk: hubspotUTK,
        // Additional empty fileds for making succesful Hubspot sync
        companyIndustry: {
          value: "",
        },
        headCount: {
          value: "",
        },
        how_many_headcounts_do_youneed: "",
        lastName: "",
        message: "",
        phoneNumber: {
          countryCode: "",
          number: "",
        },
        preferredLanguage: {
          value: "",
        },
        preferredLocation: [""],
        solutions: {
          label: "",
        },
      };
    } else {
      formData = {
        formId: "7564359/53b45baf-9ad0-4176-9e90-06e225fe17ae",
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email.toLowerCase(),
        preferredLocation: selectedEnquiryType.value === "BUSINESS" ? values.preferredLocation.map((y) => {
          return y.label;
        }): values.preferredLocation.label,
        companyName: values.companyName,
        headCount: { value: values.headcount.value },
        how_many_headcounts_do_youneed: values.headcount.value,
        companyIndustry: { value: values.companyIndustry.value },
        preferredLanguage: { value: values.preferredLanguage.value },
        phoneNumber: {
          countryCode: values.phoneNumber.countryCode,
          number: values.phoneNumber.number,
        },
        solutions: { label: values.solutions.label },
        message: values.message,
        marketing_consent: values.marketing_consent,
        pageUri:
          typeof window !== "undefined" ? window.location.href : undefined,
        pageName: typeof document !== "undefined" ? document.title : undefined,
        hutk: hubspotUTK,
      };
    }

    // API Documentation: https://legacydocs.hubspot.com/docs/methods/forms/submit_form
    const options = {
      method: "POST",
      url: `${ApiUrl}hubspot/submitForm`,
      headers: { "content-type": "application/json" },
      data: ebook ? eBookData : formData,
    };

    axios
      .request(options)
      .then(function (response) {
        //console.log("check_env", options);
        //console.log("check_env", options.url);
        if (process.env.GATSBY_ACTIVE_ENV !== "production") {
          console.log(response.data);
        }
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  // delayed render: show aliyun captcha only after 3 seconds
  useEffect(() => {
    setTimeout(() => {
      setShowCaptcha(true);
    }, 3000);
  }, []);

  return (
    <>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        onSubmit={(
          values,
          { setSubmitting, setFieldValue, setFieldTouched }
        ) => {
          // Custom Google Tag Manager Events
          typeof window.dataLayer !== "undefined" &&
            sendCustomGTMEvent(
              businessEnquiry
                ? isCxTalks
                  ? "CXTALKS"
                  : "BUSINESS"
                : selectedEnquiryType === "EBOOK"
                ? "EBOOK"
                : values.enquiryType.value
            );

          // Baidu Analytics Events
          typeof window._hmt !== "undefined" &&
            window._hmt.push([
              "_trackEvent",
              "Enquiry form",
              "Submit",
              "",
              values.enquiryType.value,
            ]);

          if (selectedEnquiryType === "EBOOK") {
            sendHubspotEvent(values);
            CmsFormPostAPI.post(
              isgreport ? getCMSEndPoint("ISGREPORT") : getCMSEndPoint("EBOOK"),
              {
                data: getAllValuesForCMS(values),
              }
            )
              .then((response) => {
                if (response.status === 200) {
                  setSubmitting(false);
                  setResponseError(null);
                  if (typeof window !== "undefined") {
                    window.open(downloadableEbook, "_blank", "fullscreen=yes");
                  }
                  setIsSent(true);
                }
              })
              .catch(() => {
                catchFormError(setSubmitting, setFieldValue, setFieldTouched);
              });
          } else {
            //Send to API
            API.post(
              getAPIEndPoint(
                businessEnquiry ? "BUSINESS" : values.enquiryType.value
              ),
              queryString.stringify(getAllValuesForAPI(values))
            )
              .then((response) => {
                if (response.status === 200) {
                  // track business enquiry form if country field is not shown (business type)
                  if (!withRespectedCountry) {
                    sendHubspotEvent(values);
                  }
                  // Send to CMS
                  CmsFormPostAPI.post(
                    getCMSEndPoint(
                      businessEnquiry ? "BUSINESS" : values.enquiryType.value
                    ),
                    {
                      data: getAllValuesForCMS(values),
                    }
                  )
                    .then((response) => {
                      if (response.status === 200) {
                        setSubmitting(false);
                        setResponseError(null);
                        setIsSent(true);
                      }
                    })
                    .catch(() => {
                      catchFormError(
                        setSubmitting,
                        setFieldValue,
                        setFieldTouched
                      );
                    });
                }
              })
              .catch(() => {
                catchFormError(setSubmitting, setFieldValue, setFieldTouched);
              });
          }
        }}
        validationSchema={getValidationSchema()}
      >
        {(props) => {
          const {
            values,
            touched,
            errors,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            setFieldTouched,
          } = props;
          return (
            <form onSubmit={handleSubmit}>
              <div className={s.formContainer}>
                <div className={s.row}>
                  {responseError && (
                    <div
                      className={ClassNames(
                        s.errorMessage,
                        s.formControl,
                        s.fullColumn
                      )}
                      style={{ textAlign: "center" }}
                    >
                      {responseError}
                    </div>
                  )}
                  {!businessEnquiry && !ebook && (
                    <div className={ClassNames(s.formControl, s.fullColumn)}>
                      <Select
                        id="enquiryType"
                        placeholder={
                          getStaticData(
                            StaticContent.placeholder_enquiry_type,
                            locale
                          ).title
                        }
                        value={values.enquiryType}
                        onChange={(id, selectedOption) => {
                          setSelectedEnquiryType({
                            value: selectedOption.value,
                            label: selectedOption.label,
                          });
                          setFieldValue("enquiryType", {
                            value: selectedOption.value,
                            label: selectedOption.label,
                          });
                          typeof window !== "undefined" &&
                            !tdcxCN &&
                            window.grecaptcha.reset();
                          setResponseError(null);
                        }}
                        onBlur={setFieldTouched}
                        touched={touched.enquiryType}
                        isDisabled={isSubmitting || isSent}
                        options={getStaticData(StaticContent.options, locale)}
                      />
                      {errors.enquiryType && touched.enquiryType && (
                        <div className={s.errorMessage}>
                          {errors.enquiryType}
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className={s.row}>
                  {!withRespectedCountry && !ebook && (
                    <div
                      className={"xs_pb_1 xs_pt_1"}
                      style={{ paddingLeft: "6px" }}
                    >
                      {featuredContact
                        ? getStaticData(
                            StaticContent.sales_inquiry_only,
                            locale
                          ).title
                        : getStaticData(
                            StaticContent.sales_inquiry_only_inner,
                            locale
                          ).title}
                    </div>
                  )}
                </div>

                {!ebook && (
                  <>
                    {" "}
                    <div className={s.row}>
                      <div
                        className={ClassNames(
                          { [s.iptComp]: featuredContact },
                          s.formControl,
                          s.halfColumn
                        )}
                      >
                        <TextField
                          id="firstName"
                          placeholder={
                            getStaticData(
                              StaticContent.placeholder_first_name,
                              locale
                            ).title
                          }
                          type="text"
                          value={values.firstName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isSubmitting || isSent}
                        />
                        {errors.firstName && touched.firstName && (
                          <div className={s.errorMessage}>
                            {errors.firstName}
                          </div>
                        )}
                      </div>

                      <div
                        className={ClassNames(
                          { [s.iptComp]: featuredContact },
                          s.formControl,
                          s.halfColumn
                        )}
                      >
                        <TextField
                          id="lastName"
                          placeholder={
                            getStaticData(
                              StaticContent.placeholder_last_name,
                              locale
                            ).title
                          }
                          type="text"
                          value={values.lastName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isSubmitting || isSent}
                        />
                        {errors.lastName && touched.lastName && (
                          <div className={s.errorMessage}>
                            {errors.lastName}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={s.row}>
                      <div
                        className={ClassNames(
                          { [s.iptComp]: featuredContact },
                          s.formControl,
                          s.halfColumn
                        )}
                      >
                        <TextField
                          id="email"
                          placeholder={
                            getStaticData(
                              StaticContent.placeholder_work_email,
                              locale
                            ).title
                          }
                          type="text"
                          value={values.email.toLowerCase()}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isSubmitting || isSent}
                        />
                        {errors.email && touched.email && (
                          <div className={s.errorMessage}>{errors.email}</div>
                        )}
                      </div>

                      <div
                        className={ClassNames(
                          { [s.iptComp]: featuredContact },
                          s.formControl,
                          s.halfColumn
                        )}
                      >
                        <Select
                          id="preferredLocation"
                          placeholder={
                            getStaticData(
                              StaticContent.placeholder_preferred_location,
                              locale
                            ).title
                          }
                          isMulti = {selectedEnquiryType.value === "BUSINESS"}
                          value={values.preferredLocation}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          touched={touched.preferredLocation}
                          isDisabled={isSubmitting || isSent}
                          options={countriesList}
                          businessEnquiry={businessEnquiry}
                        />
                        {errors.preferredLocation &&
                          touched.preferredLocation && (
                            <div className={s.errorMessage}>
                              {errors.preferredLocation}
                            </div>
                          )}
                      </div>
                    </div>
                  </>
                )}

                {ebook && (
                  <>
                    <div className={s.row}>
                      <div
                        className={ClassNames(
                          { [s.iptComp]: featuredContact },
                          s.formControl,
                          s.halfColumn
                        )}
                      >
                        <TextField
                          id="name"
                          placeholder={
                            getStaticData(
                              StaticContent.placeholder_name,
                              locale
                            ).title
                          }
                          type="text"
                          value={values.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isSubmitting || isSent}
                        />
                        {errors.name && touched.name && (
                          <div className={s.errorMessage}>{errors.name}</div>
                        )}
                      </div>

                      <div
                        className={ClassNames(
                          { [s.iptComp]: featuredContact },
                          s.formControl,
                          s.halfColumn
                        )}
                      >
                        <TextField
                          id="email"
                          placeholder={
                            getStaticData(
                              StaticContent.placeholder_work_email,
                              locale
                            ).title
                          }
                          type="text"
                          value={values.email.toLowerCase()}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isSubmitting || isSent}
                        />
                        {errors.email && touched.email && (
                          <div className={s.errorMessage}>{errors.email}</div>
                        )}
                      </div>
                    </div>

                    <div className={s.row}>
                      <div
                        className={ClassNames(
                          { [s.iptComp]: featuredContact },
                          s.formControl,
                          s.halfColumn
                        )}
                      >
                        <TextField
                          id="companyName"
                          placeholder={
                            getStaticData(
                              StaticContent.placeholder_company_name,
                              locale
                            ).title
                          }
                          type="text"
                          value={values.companyName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isSubmitting || isSent}
                        />
                        {errors.companyName && touched.companyName && (
                          <div className={s.errorMessage}>
                            {errors.companyName}
                          </div>
                        )}
                      </div>

                      <div
                        className={ClassNames(
                          { [s.iptComp]: featuredContact },
                          s.formControl,
                          s.halfColumn
                        )}
                      >
                        <TextField
                          id="jobRole"
                          placeholder={
                            getStaticData(
                              StaticContent.placeholder_jobRole,
                              locale
                            ).title
                          }
                          type="text"
                          value={values.jobRole}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isSubmitting || isSent}
                        />
                        {errors.jobRole && touched.jobRole && (
                          <div className={s.errorMessage}>{errors.jobRole}</div>
                        )}
                      </div>
                    </div>
                  </>
                )}

                <div className={s.row}>
                  {!withRespectedCountry && !ebook && (
                    <>
                      <div
                        className={ClassNames(
                          { [s.iptComp]: featuredContact },
                          s.formControl,
                          s.halfColumn
                        )}
                      >
                        <TextField
                          id="companyName"
                          placeholder={
                            getStaticData(
                              StaticContent.placeholder_company_name,
                              locale
                            ).title
                          }
                          type="text"
                          value={values.companyName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isSubmitting || isSent}
                        />
                        {errors.companyName && touched.companyName && (
                          <div className={s.errorMessage}>
                            {errors.companyName}
                          </div>
                        )}
                      </div>

                      <div className={ClassNames(s.formControl, s.halfColumn)}>
                        <Select
                          id="headcount"
                          businessEnquiry={businessEnquiry}
                          placeholder={
                            origin === "Industry Insights"
                              ? getStaticData(
                                  StaticContent.placeholder_headcount_industry_insights,
                                  locale
                                ).title
                              : getStaticData(
                                  StaticContent.placeholder_headcount,
                                  locale
                                ).title
                          }
                          value={values.headcount}
                          onChange={(id, selectedOption) => {
                            setFieldValue("headcount", {
                              value: selectedOption.value,
                              label: selectedOption.label,
                            });
                          }}
                          onBlur={setFieldTouched}
                          touched={touched.headcount}
                          isDisabled={isSubmitting || isSent}
                          options={getStaticData(
                            StaticContent.headcount,
                            locale
                          )}
                        />
                        {errors.headcount && touched.headcount && (
                          <div className={s.errorMessage}>
                            {errors.headcount}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
                <div className={s.row}>
                  {!withRespectedCountry && !ebook && (
                    <>
                      <div className={ClassNames(s.formControl, s.halfColumn)}>
                        <Select
                          id="companyIndustry"
                          placeholder={
                            getStaticData(
                              StaticContent.placeholder_industry,
                              locale
                            ).title
                          }
                          value={values.companyIndustry}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          touched={touched.companyIndustry}
                          isDisabled={isSubmitting || isSent}
                          options={getStaticData(
                            StaticContent.industry,
                            locale
                          )}
                          businessEnquiry={businessEnquiry}
                        />
                        {errors.companyIndustry && touched.companyIndustry && (
                          <div className={s.errorMessage}>
                            {errors.companyIndustry}
                          </div>
                        )}
                      </div>

                      <div className={ClassNames(s.formControl, s.halfColumn)}>
                        <Select
                          id="preferredLanguage"
                          businessEnquiry={businessEnquiry}
                          placeholder={
                            getStaticData(
                              StaticContent.placeholder_preferred_language,
                              locale
                            ).title
                          }
                          value={values.preferredLanguage}
                          onChange={(id, selectedOption) => {
                            setFieldValue("preferredLanguage", {
                              value: selectedOption.value,
                              label: selectedOption.label,
                            });
                          }}
                          onBlur={setFieldTouched}
                          touched={touched.preferredLanguage}
                          isDisabled={isSubmitting || isSent}
                          options={getStaticData(
                            StaticContent.preferredLanguage,
                            locale
                          )}
                        />
                        {errors.preferredLanguage &&
                          touched.preferredLanguage && (
                            <div className={s.errorMessage}>
                              {errors.preferredLanguage}
                            </div>
                          )}
                      </div>
                    </>
                  )}
                </div>
                {!ebook && (
                  <div className={s.row}>
                    <div
                      className={ClassNames(
                        { [s.iptTel]: featuredContact },
                        s.formControl,
                        s.halfColumn
                      )}
                    >
                      <UserIPLocation.Consumer>
                        {({ userIPLocationCode }) => {
                          const getIPLocationCode = () => {
                            return userIPLocationCode
                              ? userIPLocationCode.toLowerCase()
                              : "sg"; // defaults to 'sg'
                          };
                          const defaultCountry =
                            locale === "zh" ? "cn" : getIPLocationCode();
                          return (
                            <PhoneInput
                              flags={customFlags}
                              value={values.phoneNumber.number}
                              defaultCountry={defaultCountry}
                              preferredCountries={[
                                "sg",
                                "my",
                                "th",
                                "ph",
                                "hk",
                                "cn",
                                "jp",
                                "es",
                                "co",
                              ]}
                              disableDialCodeAndPrefix={true}
                              showDisabledDialCodeAndPrefix={true}
                              inputProps={{
                                placeholder: getStaticData(
                                  StaticContent.placeholder_phone_number,
                                  locale
                                ).title,
                                disabled: isSubmitting || isSent,
                                onBlur: () =>
                                  setFieldTouched("phoneNumber.number", true),
                              }}
                              onChange={(phone, meta) => {
                                setPhoneNumber(phone);
                                setFieldValue(
                                  "phoneNumber.number",
                                  meta.inputValue.replace(/-/g, "")
                                );
                                setFieldValue(
                                  "phoneNumber.countryCode",
                                  meta.country.dialCode
                                );
                              }}
                            />
                          );
                        }}
                      </UserIPLocation.Consumer>
                      {getIn(errors, "phoneNumber.number") &&
                        getIn(touched, "phoneNumber.number") && (
                          <div className={s.errorMessage}>
                            {getIn(errors, "phoneNumber.number")}
                          </div>
                        )}
                    </div>
                    {!withRespectedCountry && (
                      <>
                        <div
                          className={ClassNames(s.formControl, s.halfColumn)}
                        >
                          <Select
                            id="solutions"
                            placeholder={
                              getStaticData(
                                StaticContent.placeholder_solutions,
                                locale
                              ).title
                            }
                            value={values.solutions}
                            onChange={(id, selectedOption) => {
                              setFieldValue("solutions", {
                                value: selectedOption.value,
                                label: selectedOption.label,
                              });
                            }}
                            businessEnquiry={businessEnquiry}
                            onBlur={setFieldTouched}
                            touched={touched.solutions}
                            isDisabled={isSubmitting || isSent}
                            options={getStaticData(
                              StaticContent.solutions,
                              locale
                            )}
                          />
                          {errors.solutions && touched.solutions && (
                            <div className={s.errorMessage}>
                              {errors.solutions}
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                )}

                {!ebook && (
                  <div className={s.row}>
                    <div
                      className={ClassNames(
                        { [s.iptComp]: featuredContact },
                        s.formControl,
                        s.fullColumn
                      )}
                    >
                      <TextField
                        id="message"
                        placeholder={
                          getStaticData(
                            StaticContent.placeholder_message,
                            locale
                          ).title
                        }
                        type="textarea"
                        value={values.message}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={isSubmitting || isSent}
                      />
                      {errors.message && touched.message && (
                        <div className={s.errorMessage}>{errors.message}</div>
                      )}
                    </div>
                  </div>
                )}
                {!ebook && (
                  <div className={s.row}>
                    <div
                      className={ClassNames(
                        { [s.cbox]: featuredContact },
                        s.formControl,
                        s.fullColumn,
                        s.termsPrivacy
                      )}
                    >
                      <div
                        className={s.checkboxCont}
                        // style={{ display: "flex", justifyContent: "center" }}
                      >
                        <div className={s.checkboxWidthTerm}>
                          <Field
                            name="hasAgreedTerm"
                            type="checkbox"
                            checked={values.hasAgreedTerm}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            component={Checkbox1}
                            themeSecondary
                            disabled={isSubmitting || isSent}
                            label={
                              <>
                                {getStaticData(
                                  StaticContent.form_read_terms_privacy_1,
                                  locale
                                )}{" "}
                                <a
                                  href="/policies/terms-of-use"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {getStaticData(
                                    StaticContent.form_read_terms_link,
                                    locale
                                  )}
                                </a>{" "}
                                {getStaticData(
                                  StaticContent.form_read_terms_privacy_2,
                                  locale
                                )}{" "}
                                <a
                                  href="/policies/privacy"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {getStaticData(
                                    StaticContent.form_read_privacy_link,
                                    locale
                                  )}
                                </a>
                                {getStaticData(
                                  StaticContent.form_read_terms_privacy_3,
                                  locale
                                )}
                              </>
                            }
                          />
                          <div style={{ textAlign: "center" }}>
                            {errors.hasAgreedTerm && touched.hasAgreedTerm && (
                              <span className={s.errorMessage}>
                                {errors.hasAgreedTerm}
                              </span>
                            )}
                          </div>

                          <Field
                            name="marketing_consent"
                            type="checkbox"
                            checked={values.marketing_consent}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            component={Checkbox2}
                            themeSecondary
                            disabled={isSubmitting || isSent}
                            label={
                              <>
                                {getStaticData(
                                  StaticContent.form_read_terms_privacy_4,
                                  locale
                                )}{" "}
                                <a
                                  href="/policies/privacy"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {getStaticData(
                                    StaticContent.form_read_privacy_link,
                                    locale
                                  )}
                                </a>
                                {getStaticData(
                                  StaticContent.form_read_terms_privacy_3,
                                  locale
                                )}
                              </>
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className={s.row}>
                  <div
                    className={ClassNames(
                      s.formControl,
                      s.fullColumn,
                      s.submit
                    )}
                  >
                    {!ebook && (
                      <>
                        {tdcxCN ? (
                          <div className={s.aliyunCaptcha}>
                            {showCaptcha ? (
                              <ALiYunCaptcha
                                appKey="FFFF0N00000000009650"
                                scene="nc_activity"
                                onCallback={(response) => {
                                  let captchaObj = Object.assign({}, response);
                                  setFieldValue("captcha", captchaObj);
                                }}
                              />
                            ) : (
                              ""
                            )}
                            {errors.captcha && touched.captcha && (
                              <div className={s.errorMessage}>
                                {errors.captcha}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className={s.recaptcha}>
                            <ReCAPTCHA
                              sitekey="6LdVcW4UAAAAAKuKApZRto--mo9S8ujjv0uFFHye"
                              onChange={(response) => {
                                setFieldValue("captcha", response);
                              }}
                            />
                            {errors.captcha && touched.captcha && (
                              <div className={s.errorMessage}>
                                {errors.captcha}
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    )}
                    <div className={s.buttonCta}>
                      {ebook ? (
                        <Button
                          type="submit"
                          variant={themeSecondary ? "secondary" : "primary"}
                          size="large"
                          disabled={isSubmitting || isSent}
                        >
                          {getStaticData(StaticContent.ebook_download, locale)}
                        </Button>
                      ) : (
                        <Button
                          type="submit"
                          variant={themeSecondary ? "secondary" : "primary"}
                          size="large"
                          disabled={isSubmitting || isSent}
                        >
                          {isSubmitting &&
                            getStaticData(StaticContent.sending, locale).title}
                          {!isSubmitting &&
                            !isSent &&
                            getStaticData(StaticContent.send, locale).title}
                          {isSent &&
                            getStaticData(StaticContent.sent, locale).title}
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
                {ebook &&  !report && (
                  <div className={s.row}>
                    <div className={ClassNames(s.formControl, s.fullColumn)}>
                      {getStaticData(
                        StaticContent.ebook_privacy_policy1,
                        locale
                      )}
                      <a
                        href="/policies/privacy"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {getStaticData(
                          StaticContent.ebook_privacy_policy2,
                          locale
                        )}
                      </a>
                      {getStaticData(
                        StaticContent.ebook_privacy_policy3,
                        locale
                      )}
                      <a
                        href="/contact?getintouch"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {getStaticData(
                          StaticContent.ebook_privacy_policy4,
                          locale
                        )}
                      </a>
                      {getStaticData(
                        StaticContent.ebook_privacy_policy5,
                        locale
                      )}
                    </div>
                    <div className={ClassNames(s.formControl, s.fullColumn)}>
                      {getStaticData(
                        StaticContent.ebook_privacy_policy6,
                        locale
                      )}
                      <span className={s.highlight}>
                        {getStaticData(
                          StaticContent.ebook_privacy_policy7,
                          locale
                        )}
                      </span>
                      {getStaticData(
                        StaticContent.ebook_privacy_policy8,
                        locale
                      )}
                    </div>
                  </div>
                )}
                {report &&
                  <div className={s.row}>
                  <div className={ClassNames(s.formControl, s.fullColumn)}>
                  {getStaticData(
                        StaticContent.report_privacy_policy1,
                        locale
                      )}
                      <a
                        href="/policies/privacy"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {getStaticData(
                          StaticContent.report_privacy_policy2,
                          locale
                        )}
                      </a>
                      {getStaticData(
                        StaticContent.report_privacy_policy3,
                        locale
                      )}
                      <a
                        href="/contact?getintouch"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {getStaticData(
                          StaticContent.report_privacy_policy4,
                          locale
                        )}
                      </a>
                      {getStaticData(
                        StaticContent.report_privacy_policy5,
                        locale
                      )}
                  </div>
                  <div className={ClassNames(s.formControl, s.fullColumn)}>
                    {getStaticData(
                      StaticContent.report_privacy_policy6,
                      locale
                    )}
                    <span className={s.highlight}>
                      {getStaticData(
                        StaticContent.report_privacy_policy7,
                        locale
                      )}
                    </span>
                    {getStaticData(
                      StaticContent.report_privacy_policy8,
                      locale
                    )}
                  </div>
                </div>
                }
              </div>
            </form>
          );
        }}
      </Formik>
    </>
  );
};

export default EnquiryForm;
